'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var companionEvents = {
  loaded: 'companion.ad.loaded',
  clicked: 'companion.ad.clicked',
  clickError: 'companion.ad.clickError',
  renderError: 'companion.ad.renderError',
  refreshDisplaySlot: 'companion.ad.refresh.slot'
};

exports.default = companionEvents;